document.addEventListener("DOMContentLoaded", () => {
  const superSearch = document.querySelector('.super-search');
  const searchResultsModal = document.querySelector(".search-results-modal");

  function handleScroll() {
    const searchResultsModal = document.querySelector(".search-results-modal");
    const searchSuggestions = superSearch.querySelector(".search-suggestions");
    const historySearch = document.querySelector('.history-search');
    const sliderProducts = document.querySelector('.super-search-products-slider');

    if (
      !searchResultsModal ||
      searchResultsModal.classList.contains("hidden")
    ) {
      return;
    }

    const productList = searchResultsModal.querySelector("#filter-results");
    if (!productList) {
      return;
    }

    const currentScrollTop = productList.scrollTop;

    if (currentScrollTop > 0) {
      searchSuggestions?.classList.add("collapse");
      superSearch?.classList.add('vjp-collapse');
      historySearch?.classList.add('collapse');
      sliderProducts?.classList.add('collapse');
    } else {
      searchSuggestions?.classList.remove("collapse");
      superSearch?.classList.remove('vjp-collapse');
      historySearch?.classList.remove('collapse');
      sliderProducts?.classList.remove('collapse');
    }
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        if (!searchResultsModal.classList.contains("hidden")) {
          const productList =
            searchResultsModal.querySelector("#filter-results");
          if (productList) {
            productList.addEventListener("scroll", handleScroll);
          }
        }
      }
    });
  });

  if (searchResultsModal) {
    observer.observe(searchResultsModal, { attributes: true });
  }


  function cleanupScrollEffect() {
    observer.disconnect();
    const productList = searchResultsModal.querySelector("#filter-results");
    if (productList) {
      productList.removeEventListener("scroll", handleScroll);
    }
  }

  window.cleanupSearchScrollEffect = cleanupScrollEffect;
});
